<mat-table
  class="camera-table"
  [dataSource]="items"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.name' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <div *ngIf="item.type?.icon; then hasIcon; else noIcon"></div>
      <ng-template #hasIcon>
        <sn-icon fontSet="fs" [fontIcon]="item.type?.icon" class="fs-mr-xs"></sn-icon>
      </ng-template>
      <ng-template #noIcon>
        <sn-icon fontSet="fs" [fontIcon]="'f1ad'" class="fs-mr-xs"></sn-icon>
      </ng-template>
      <span class="fs-text-truncate">{{ item.name }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="type">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.type' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <div class="fs-text-truncate">
        {{ item.type?.name }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="address">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.address' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.address }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="city">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.city' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.city }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="state">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.state' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ item.state }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="zip">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'vault.incidents.fieldsGenerator.zip' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.zip }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="owner">
    <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-owner [object]="item"></sn-object-owner>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="sharing">
    <mat-header-cell *matHeaderCellDef>{{ 'common.sharing' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-share-status [object]="item"></sn-object-share-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="cameras">
    <mat-header-cell *matHeaderCellDef>{{ 'common.cameras' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-camera-stats [stats]="item.stats"></sn-camera-stats>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="internal">
    <mat-header-cell *matHeaderCellDef>{{ 'dashboard.main.internalCameras' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.internalCamera }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="external">
    <mat-header-cell *matHeaderCellDef>{{ 'dashboard.main.externalCameras' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.externalCamera }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="createdTimestamp">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.created' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.createdTimestamp | fsFormatDate : 'medium' }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="tags">
    <mat-header-cell *matHeaderCellDef>{{ 'common.tags' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-tag-view-list [tags]="item.tags" (tagSelected)="onTagSelected($event)"></sn-tag-view-list>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
